export const textFieldStyle = {
  '& label': {
    fontSize: '1rem',
  },
  '& .MuiOutlinedInput-root': {
    fontSize: '1rem',
  },
}

export const inputFieldStyle = {
  '& .MuiInputBase-input': {
    fontSize: '1rem',
  },
}
